var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionArchitectureBgShapeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 345,
    viewBox: "0 0 380 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2349_4338",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -66,
    width: 380,
    height: 411
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6.10352e-05 -66L379.96 -66L379.96 344.72L-6.10352e-05 344.72L-6.10352e-05 -66Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2349_4338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-160.66 83.8695C-210.14 133.35 -210.14 213.579 -160.66 263.069C-128.36 295.359 -79.9895 307.849 -36.0795 295.279C-10.0495 287.829 6.15046 271.609 26.8505 255.209C89.5805 205.499 175.7 158.099 257.01 191.059C280.9 200.749 256.67 153.529 252.93 146.509C178.77 7.26949 -4.50953 -36.0805 -131.94 58.9995C-142.1 66.5795 -151.7 74.8995 -160.66 83.8695Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-152.44 87.8095C-199.67 135.039 -199.67 211.609 -152.44 258.839C-121.62 289.669 -75.4498 301.579 -33.5398 289.589C-8.69981 282.479 6.77019 266.999 26.5202 251.349C86.3902 203.899 168.59 158.659 246.2 190.119C269.01 199.359 245.88 154.299 242.31 147.589C171.53 14.6995 -3.3998 -26.6805 -125.02 64.0695C-134.72 71.3095 -143.88 79.2495 -152.44 87.7995V87.8095Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.23 91.7494C-189.21 136.729 -189.21 209.649 -144.23 254.619C-114.87 283.969 -70.9098 295.319 -30.9998 283.899C-7.33985 277.129 7.38016 262.389 26.1902 247.479C83.2002 202.299 161.48 159.219 235.39 189.169C257.11 197.969 235.08 155.059 231.68 148.669C164.28 22.1194 -2.30984 -17.2806 -118.12 69.1394C-127.35 76.0294 -136.08 83.5894 -144.23 91.7394V91.7494Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-136.009 95.6898C-178.729 138.41 -178.729 207.68 -136.009 250.4C-108.129 278.28 -66.3688 289.06 -28.4588 278.21C-5.98883 271.78 8.00118 257.78 25.8712 243.62C80.0212 200.7 154.381 159.78 224.581 188.24C245.211 196.6 224.291 155.84 221.061 149.77C157.031 29.5599 -1.19882 -7.87013 -111.209 74.2199C-119.979 80.7599 -128.269 87.9499 -136.009 95.6898Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-127.79 99.6298C-168.26 140.1 -168.26 205.71 -127.79 246.18C-101.38 272.58 -61.8201 282.8 -25.9101 272.52C-4.62008 266.43 8.62993 253.17 25.5499 239.75C76.8499 199.1 147.28 160.33 213.78 187.29C233.32 195.21 213.5 156.6 210.44 150.85C149.79 36.9798 -0.0900764 1.52979 -104.3 79.2898C-112.61 85.4898 -120.46 92.2998 -127.79 99.6298Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.579 103.57C-157.789 141.78 -157.789 203.74 -119.579 241.95C-94.6388 266.89 -57.2788 276.53 -23.3788 266.83C-3.27883 261.08 9.23118 248.55 25.2212 235.89C73.6612 197.5 140.171 160.9 202.961 186.35C221.411 193.83 202.701 157.37 199.811 151.94C142.541 44.4198 1.00117 10.9398 -97.3988 84.3598C-105.249 90.2098 -112.659 96.6398 -119.579 103.56V103.57Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111.36 107.509C-147.32 143.469 -147.32 201.769 -111.36 237.729C-87.8901 261.199 -52.7401 270.269 -20.8301 261.139C-1.92008 255.729 9.85992 243.939 24.8999 232.019C70.4799 195.889 133.07 161.449 192.16 185.399C209.52 192.439 191.91 158.129 189.19 153.019C135.3 51.8392 2.10992 20.3292 -90.4901 89.4292C-97.8701 94.9392 -104.85 100.989 -111.36 107.499V107.509Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103.139 111.45C-136.849 145.16 -136.849 199.8 -103.139 233.51C-81.1394 255.51 -48.1894 264.01 -18.2894 255.45C-0.559376 250.38 10.4806 239.33 24.5706 228.16C67.2906 194.3 125.961 162.01 181.341 184.46C197.621 191.06 181.111 158.9 178.561 154.11C128.051 59.2697 3.21062 29.7396 -83.5894 94.5096C-90.5094 99.6696 -97.0494 105.34 -103.159 111.45H-103.139Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94.9301 115.39C-126.38 146.84 -126.38 197.83 -94.9301 229.29C-74.4001 249.82 -43.6601 257.75 -15.7501 249.77C0.789925 245.03 11.0899 234.73 24.2499 224.3C64.1199 192.7 118.86 162.58 170.54 183.53C185.73 189.69 170.33 159.68 167.95 155.21C120.81 66.7099 4.31993 39.1599 -76.6601 99.5899C-83.1201 104.41 -89.2201 109.7 -94.9201 115.4L-94.9301 115.39Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-86.7094 119.33C-115.909 148.53 -115.909 195.87 -86.7094 225.06C-67.6494 244.12 -39.1094 251.48 -13.1994 244.07C2.16063 239.67 11.7206 230.11 23.9306 220.43C60.9406 191.1 111.761 163.13 159.741 182.58C173.841 188.29 159.541 160.44 157.331 156.29C113.571 74.1296 5.42063 48.5496 -69.7594 104.65C-75.7494 109.12 -81.4194 114.03 -86.7094 119.32V119.33Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionArchitectureBgShapeRed);
export default __webpack_public_path__ + "static/media/solution_architecture_bg_shape_red.c3f43d1a7c18bcbe13db39161a7f4d79.svg";
export { ForwardRef as ReactComponent };